<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-08 17:28:28
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-08 17:35:46
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\buyerRemark.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="pl-16 pr-14" style="width: 100px">
		<el-tooltip class="item" effect="dark" v-ak-tooltip-auto-show :content="`${row.buyer_remark}`" placement="top">
			<span class="yx-color-text-primary font-h6-regular yx-color-text-primary line-ellipsis-3" style="width: 100%"
				>备注：{{ row.buyer_remark ? row.buyer_remark : '无' }}</span
			>
		</el-tooltip>
	</div>
</template>
<script>
export default {
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
</style>